export default "<embed width=\"807px\" height=\"8075px\" [src]=\"url |safe\" *ngIf='url' />"